import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import Model from 'flarum/common/Model';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionHero from 'flarum/forum/components/DiscussionHero';
import KeyMetadataModal from './components/KeyMetadataModal';
import { hasKeysTag } from './utils/keysTag';
export default function addKeyMetadataDetails() {
  // Discussion.keyMetadata() -> {author, language} or null, already
  // resolved server-side (see the `keyMetadata` field on DiscussionResource
  // in extend.php).
  Object.defineProperty(Discussion.prototype, 'keyMetadata', {
    value: Model.attribute('keyMetadata')
  });

  // Discussion.canEditKeyMetadata() -> bool, true only for the discussion's
  // author or a moderator/admin (mirrors the same check in the
  // keyMetadata field's set() on the server).
  Object.defineProperty(Discussion.prototype, 'canEditKeyMetadata', {
    value: Model.attribute('canEditKeyMetadata')
  });

  // In the discussion page's hero, next to the title - shows the key's
  // author/language when set, plus an inline "Ajouter les informations"/
  // "Modifier" link for anyone allowed to change it. Mirrors champis-events'
  // addEventDetails.js exactly, same -1 priority slot (the two tags are
  // mutually exclusive, so this never actually collides with the event
  // block).
  extend(DiscussionHero.prototype, 'items', function (items) {
    const discussion = this.attrs.discussion;
    const metadata = discussion.keyMetadata && discussion.keyMetadata();
    const canEdit = discussion.canEditKeyMetadata && discussion.canEditKeyMetadata();
    const relevant = hasKeysTag(discussion.tags ? discussion.tags() : []);
    if (!metadata && !(canEdit && relevant)) return;
    const t = key => app.translator.trans(`champis-keys.forum.key_metadata.${key}`);
    const openModal = () => app.modal.show(KeyMetadataModal, {
      discussion,
      onsubmit: newMetadata => discussion.save({
        keyMetadata: newMetadata
      })
    });
    items.add('keyMetadata', m("ul", {
      className: "DiscussionHero-keyMetadata"
    }, metadata && metadata.author && m("li", null, m("i", {
      className: "icon fas fa-user",
      "aria-hidden": "true"
    }), " ", metadata.author), metadata && metadata.language && m("li", null, m("i", {
      className: "icon fas fa-language",
      "aria-hidden": "true"
    }), " ", metadata.language), canEdit && relevant && m("li", null, m("a", {
      className: "DiscussionHero-keyMetadataEdit",
      onclick: openModal
    }, m("i", {
      className: "icon fas fa-info-circle",
      "aria-hidden": "true"
    }), ' ', t(metadata && (metadata.author || metadata.language) ? 'edit_link' : 'add_link')))), -1);
  });
}